import * as React from 'react';
import { SymbolType, SystemType } from '@shared/types/tsk';

export const ZOOM_SENSITIVITY_WHEEL = 0.001;
export const BASE_ICON_SIZE = 32;
export const BASE_NODE_RADIUS = 3;
export const BASE_PIPE_WIDTH = 2;
export const HIT_RADIUS_PX = 48;
export const DRAG_THRESHOLD = 8;
export const CLICK_GUARD_MS = 300;
export const OBJECT_SNAP_TOLERANCE_PX = 14;
export const INITIAL_VIEW_PADDING = 40;

export const availableFixtures = [
    SymbolType.WC, SymbolType.BASIN, SymbolType.SHOWER, SymbolType.BATH,
    SymbolType.SINK, SymbolType.WASHING_MACHINE, SymbolType.DISHWASHER,
    SymbolType.LAUNDRY_TUB, SymbolType.FLOOR_WASTE, SymbolType.TUNDISH
];
export const availableFittings = [
    SymbolType.IO, SymbolType.IOS, SymbolType.CO, SymbolType.COS,
    SymbolType.ORG, SymbolType.SWIVEL_JOINT, SymbolType.EXPANSION_JOINT
];
export const availableDirections = [
    SymbolType.RISER, SymbolType.DROPPER
];
